import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";
import { Loader2 } from "lucide-react" 
import { cn } from "@/lib/utils"
import { AI } from "@/assets/features/editor";

const buttonVariants = cva(
  "inline-flex items-center  capitalize disabled:cursor-not-allowed font-Poppins font-semibold  justify-center cursor-pointer gap-2 whitespace-nowrap rounded-md text-sm  transition-all  disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-white shadow-xs hover:bg-primary/90 rounded-full",
        destructive:
          " bg-red-500 rounded-full text-white shadow-xs  hover:text-white/90 ",
        outline:
          "border-[0.1px] border-secondary-foreground !text-secondary rounded-full text-primary shadow-xs hover:bg-accent dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary:
          "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost:
          "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8  rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)


const Button = React.forwardRef(
  ({
    className,
    variant,
    size,
    asChild = false,
    loading = false,
    children, 
type,
    ...props
  }, ref) => {
    const Comp = asChild ? Slot : "button"

    const disabled = props.disabled || loading;

    return (
      <Comp
        data-slot="button"
        data-loading={loading ? 'true' : undefined} 
        className={cn(
          buttonVariants({ variant, size, className }),
          loading && "opacity-80 pointer-events-none" 
        )}
        disabled={disabled} 
        ref={ref}
        {...props}
        type={type}
      >
        {loading ? (
          <Loader2 className="h-4 w-4 animate-spin shrink-0" /> 
        ) : (
          children
        )}
      </Comp>
    );
  }
)
Button.displayName = "Button"



const AIButton = React.forwardRef(
  ({
    className,
    children,
    ...props
  }, ref) => {
    const aiButtonClasses =
      "text-xs rounded-full px-3 py-2 h-9 text-white " +
      "bg-[linear-gradient(104deg,#076698_35.11%,#054567_76.73%,#022232_121.67%)]";

    const showAiIcon = !props.loading;

    return (
      <Button
        variant="default"
        size="sm" // Using 'sm' for a smaller button base
        className={cn(aiButtonClasses, className)} // Merge AI classes and any custom classes
        ref={ref}
        {...props}
      >
        {/* Render AI icon only if not loading */}
        {showAiIcon && <AI className="h-4 w-4 shrink-0" />} 
        {children}
      </Button>
    );
  }
)
AIButton.displayName = "AIButton"


export { Button, buttonVariants, AIButton } 